module.exports = __webpack_public_path__ + "img/filter-type-core--active.c2db3dc8.svg";